import{jsx as e}from"react/jsx-runtime";import{styled as r}from"styled-components";import{useItemName as t}from"../../../../domain/hooks/useItemName.mjs";import{Label as o}from"../Label/Label.mjs";const i=r.div`
  float: left;
  width: 140px;
  min-height: 22px;
  padding: 0px 4px 0px 32px;
  margin: 0px 8px 2px 0px;
  border: 1px solid #cccccc;
  border-top: 0px;
  ${e=>{if(e.$required)return"background: url('images/required.png') 0px 0px no-repeat;"}}
`,p=r(o)`
  margin-top: 3.5px;
  text-align: left;
  color: #333333;
  font-weight: bold;
`;function m({itemName:r,required:o=!1}){const m=t();return e(i,{$required:o,className:"field-head",children:e(p,{type:"block",className:"field-title",children:m(r)})})}export{m as FieldHead};
